/** APICloseMeRequest classId — Playtech poker signals the host should close the game frame. */
export const PLAYTECH_CLOSE_FRAME_CLASS_ID = 11;
